/* eslint-disable */
// @ts-nocheck
 
 
/* eslint-disable prefer-template */
 
 
/* eslint-disable padding-line-between-statements */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
 
 
 
 
/* eslint-disable no-nested-ternary */
import html2pdf from 'html2pdf.js';

/**
 * Generate a Settlement PDF with ERP journal suggestion (visual only, not accounting).
 * Updated to match ReviewSettlement component design with additional bank transfer info.
 *
 * Expected settlementData shape:
 * {
 *   id: string | number,
 *   sender: string,                  // sender organization name
 *   beneficiary: string,             // beneficiary organization name
 *   fromDate: string,                // settlement period start date
 *   toDate: string,                  // settlement period end date
 *   currency: string,                // e.g. 'EGP'
 *   amount: number,                  // net settlement amount
 *   status: string,                  // settlement status ('Cleared', 'Draft', etc.)
 *   senderBank: string,              // sender bank account display
 *   beneficiaryBank: string,         // beneficiary bank account display
 *   senderBankName?: string,         // sender bank name
 *   beneficiaryBankName?: string,    // beneficiary bank name
 *   bank_ref_no?: string,            // ACH reference number (only when cleared)
 *   bank_description?: string,       // transfer description (only when cleared)
 *   bank_transfer_date?: string,     // transfer date (only when cleared)
 *   notes?: string,                  // additional notes
 *   senderJournalEntries: Array<{    // sender journal entries
 *     account: string,
 *     debit: number,
 *     credit: number,
 *     description: string
 *   }>,
 *   beneficiaryJournalEntries: Array<{ // beneficiary journal entries
 *     account: string,
 *     debit: number,
 *     credit: number,
 *     description: string
 *   }>
 * }
 *
 * Returns: Promise<void> (triggers browser download)
 */

/**
 * @param {Object} settlementData - Settlement data object
 * @param {Object} intl - Internationalization object for translations
 * @returns {string} HTML content string
 */
export const generateSettlementHTML = (settlementData, intl) => {
    // Helper function to format dates as dd-mm-yyyy
    const formatDate = (dateString) => {
        if (!dateString) return '-';

        let date;
        // Handle different date formats
        if (typeof dateString === 'string') {
            // If it's an ISO string or standard format, use it directly
            if (dateString.includes('T') || dateString.includes('-')) {
                date = new Date(dateString);
            } else {
                // If it's in MM/DD/YYYY format, convert to proper format
                const parts = dateString.split('/');
                if (parts.length === 3) {
                    // Assume MM/DD/YYYY and convert to YYYY-MM-DD
                    date = new Date(`${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`);
                } else {
                    date = new Date(dateString);
                }
            }
        } else {
            date = new Date(dateString);
        }

        // Check if the date is valid
        if (isNaN(date.getTime())) return '-';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    try {
        // Detect if we're using Arabic language
        const isArabic = intl && intl.locale && intl.locale.includes('ar');
    } catch (error) {
        console.error('Error generating settlement HTML:', error);
    }

    // Helper function to format financial values
    const formatAmount5 = (value) => {
        return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 });
    };
    const formatAmount2 = (value) => {
        return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // Define getAccountName function to translate account names
    const getAccountName = (accountName) => {
        if (!intl) return accountName;

        // Map common account names to translated versions (remove codes)
        const accountMappings = {
            // Common patterns with codes that need translation
            'Unsettled Dues (11200)': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
            'Bank Account (10100)': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
            'Commission Income (40100)': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
            'VAT Payable (20300)': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
            'Operating Account (10100)': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
            'Fare Revenue (40100)': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
            'Commission Expense (50100)': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
            'VAT Receivable (10200)': intl.formatMessage({ id: 'settlement_VATReceivableAccount' }),
            // Also handle versions without codes
            'Unsettled Dues': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
            'Bank Account': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
            'Commission Income': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
            'VAT Payable': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
            'Operating Account': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
            'Fare Revenue': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
            'Commission Expense': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
            'VAT Receivable': intl.formatMessage({ id: 'settlement_VATReceivableAccount' })
        };

        return accountMappings[accountName] || accountName;
    };

    // Helper function to translate status values
    const getTranslatedStatus = (status) => {
        if (!intl) return status;

        const statusTranslations = {
            'Draft': intl.formatMessage({ id: 'settlement_StatusDraft' }),
            'Confirmed': intl.formatMessage({ id: 'settlement_StatusConfirmed' }),
            'Cleared': intl.formatMessage({ id: 'settlement_StatusCleared' }),
            'Reversed': intl.formatMessage({ id: 'settlement_StatusReversed' }),
            'Pending': intl.formatMessage({ id: 'settlement_StatusPending' })
        };

        return statusTranslations[status] || status;
    };

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="UTF-8">
        <title>${intl ? intl.formatMessage({ id: 'settlement_SettlementReport' }) : 'Settlement Report'} - ${settlementData.id}</title>
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
            }
            
            body {
                font-family: 'Arial', sans-serif;
                line-height: 1.4;
                color: #000;
                background: #fff;
            }
            
            .container {
                max-width: 800px;
                margin: 0 auto;
                padding: 20px;
            }
            
            .header {
                text-align: center;
                border-bottom: 2px solid #000;
                padding-bottom: 16px;
                margin-bottom: 24px;
            }
            
            .header h1 {
                color: #000;
                font-size: 18px;
                margin-bottom: 6px;
                font-weight: 700;
            }
            
            .header .subtitle {
                color: #000;
                font-size: 12px;
            }
            
            .settlement-info {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 16px;
                margin-bottom: 20px;
            }
            
            .info-section {
                background: #fff;
                padding: 12px;
                border-radius: 0;
                border: 1px solid #000;
            }
            
            .info-section h3 {
                color: #000;
                margin-bottom: 8px;
                font-size: 12px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                font-weight: 500;
            }
            
            .info-row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 6px;
                padding: 2px 0;
                font-size: 11px;
            }
            
            .info-row:last-child {
                margin-bottom: 0;
            }
            
            .info-label {
                font-weight: 700;
                color: #000;
                font-size: 11px;
            }
            
            .info-value {
                color: #000;
                font-size: 11px;
            }
            
            .amount-highlight {
                font-size: 11px;
                font-weight: 700;
                color: #000;
            }
            
            .journal-section {
                margin: 20px 0;
            }
            
            .journal-section h3 {
                color: #000;
                margin-bottom: 10px;
                font-size: 12px;
                border-bottom: 1px solid #000;
                padding-bottom: 6px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                font-weight: 500;
            }
            
            .journal-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 16px;
                font-size: 11px;
            }
            
            .journal-table th,
            .journal-table td {
                padding: 4px;
                text-align: left;
                border-bottom: 1px solid #000;
                font-size: 11px;
            }
            
            .journal-table th {
                background: #fff;
                color: #000;
                font-weight: 700;
                border-top: 1px solid #000;
                border-bottom: 2px solid #000;
                font-size: 11px;
            }
            
            .amount-cell {
                text-align: right;
                font-weight: 700;
            }
            
            .total-row {
                background: #fff !important;
                font-weight: 700;
                border-top: 2px solid #000;
            }
            
            .balanced {
                color: #000;
                font-weight: 700;
            }
            
            .bank-transfer {
                background: #fff;
                padding: 12px;
                border-radius: 0;
                margin: 16px 0;
                border: 1px solid #000;
            }
            
            .bank-transfer h3 {
                color: #000;
                margin-bottom: 8px;
                text-transform: uppercase;
            }
            
            .transfer-flow {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
                margin: 10px 0;
            }
            
            .bank-box {
                background: #fff;
                padding: 10px;
                border-radius: 0;
                border: 1px solid #000;
                text-align: center;
                min-width: 180px;
            }
            
            .arrow {
                font-size: 14px;
                color: #000;
                font-weight: 700;
            }
            
            .notes-section {
                background: #fff;
                border: 1px solid #000;
                border-radius: 0;
                padding: 10px;
                margin: 16px 0;
            }
            
            .notes-section h4 {
                color: #000;
                margin-bottom: 4px;
                text-transform: uppercase;
            }
            
            .footer {
                margin-top: 24px;
                padding-top: 12px;
                border-top: 1px solid #000;
                text-align: center;
                color: #000;
                font-size: 11px;
            }
            
            .signature-section {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 24px;
                margin: 24px 0 16px 0;
            }
            
            .signature-box {
                text-align: center;
                padding: 16px;
                border: 1px solid #000;
                border-radius: 0;
                font-size: 11px;
            }
            
            .signature-line {
                border-top: 1px solid #333;
                margin: 20px 16px 8px 16px;
            }
            
            .footer {
                margin-top: 24px;
                padding-top: 12px;
                border-top: 1px solid #000;
                text-align: center;
                color: #000;
                font-size: 11px;
            }
            
            @media print {
                .container {
                    max-width: none;
                    padding: 0;
                }
                
                body {
                    font-size: 11px;
                }
                
                .header h1 {
                    font-size: 18px;
                }
                
                .journal-table {
                    font-size: 10px;
                }
                .journal-table th {
                    font-size: 10px;
                }
            }
        </style>
    </head>
    <body>
         <div class="container">
              <!-- Header -->
              <div class="header"style="margin-bottom:8px;">
                  <h1>${intl.formatMessage({ id: 'settlement_SettlementReport' })}</h1>
                  
                  <div class="subtitle"> ${settlementData.id}</div>
                   
                          <!-- Created Date Section (for Confirmed, Cleared, Reversed statuses) -->
              ${['Confirmed', 'Cleared', 'Reversed'].includes(settlementData.status) && settlementData.created_at ? `
                 <div class="info-row"style="margin-bottom:-10px;text-align: center;display:flex;justify-content:center;">
                          <span class="info-label" style="text-align:center;">${intl.formatMessage({ id: 'settlement_CreatedAt' })}: ${formatDate(settlementData.created_at)}</span>
                  </div>
              ` : ''}

               ${settlementData.status !== 'Cleared' ? `
                          <div class="info-row"style="margin-top:-30px;">
                              <span class="info-label" style=" font-size: 12px;">${intl.formatMessage({ id: 'settlement_StatusLabel' })}: ${getTranslatedStatus(settlementData.status)}</span>
                          </div>
                      ` : ''}
              <!-- Reversal Reason Section (for Reversed status) -->
              ${settlementData.status === 'Reversed' && settlementData.reversal_reason ? `
                  <div >
                   
                           <div class="info-row"style="margin:5px;">
                              <span class="info-label" style=" font-size: 12px;">${intl.formatMessage({ id: 'settlement_ReversalReason' })}: ${settlementData.reversal_reason}</span>
                          </div>
                      ${settlementData.reversed_at ? `
                              <div class="info-row"style="margin-bottom:-5px;">
                              <span class="info-label" style="font-size: 12px;">${intl.formatMessage({ id: 'settlement_ReversedAt' })}: ${formatDate(settlementData.reversed_at)}</span>
                          </div>
                      ` : ''}
                  </div>
              ` : ''}


              </div>

            <!-- Period Section -->
            <div style="margin-bottom:5px;">
                <span class="info-label">${intl ? intl.formatMessage({ id: 'settlement_From' }) : 'From'}:</span>
                <span class="info-value">${settlementData.fromDate || '-'}</span>
                <span class="info-label">${intl ? intl.formatMessage({ id: 'settlement_To' }) : 'To'}:</span>
                <span class="info-value">${settlementData.toDate || '-'}</span>
            </div>

            <!-- Parties & Banks Section -->
            <div class="settlement-info">
                <div class="info-section">
                    <strong style="display:block;margin: 0 0 5px 0;">${intl ? intl.formatMessage({ id: 'settlement_SenderOurCompany' }) : 'Sender (Our Company)'}</strong>
                    <div class="info-row"style=" display: flex;justify-content: flex-start;">
                        <span class="info-label"style="display:block;width:34%;">${intl ? intl.formatMessage({ id: 'settlement_Organisation' }) : 'Organisation'}:</span>
                        <span class="info-value">${settlementData.sender}</span>
                    </div>
                    <div class="info-row"style=" display: flex;justify-content: flex-start;">
                        <span class="info-label"style="display:block;width:34%;">${intl ? intl.formatMessage({ id: 'settlement_Bank' }) : 'Bank'}:</span>
                        <span class="info-value">${settlementData.senderBankName || '-'}</span>
                    </div>
                    <div class="info-row"style=" display: flex;justify-content: flex-start;">
                        <span class="info-label"style="display:block;width:34%;">${intl ? intl.formatMessage({ id: 'settlement_BankAccount' }) : 'Bank Account'}:</span>
                        <span class="info-value">${settlementData.senderBank}</span>
                    </div>
                </div>

                <div class="info-section">
                   <strong style="display:block;margin: 0 0 5px 0;">${intl ? intl.formatMessage({ id: 'settlement_BeneficiaryPTO' }) : 'Beneficiary (PTO)'}</strong>
                    <div class="info-row"style=" display: flex;justify-content: flex-start;">
                        <span class="info-label"style="display:block;width:34%;">${intl ? intl.formatMessage({ id: 'settlement_Organisation' }) : 'Organisation'}:</span>
                        <span class="info-value">${settlementData.beneficiary}</span>
                    </div>
                    <div class="info-row"style=" display: flex;justify-content: flex-start;">
                        <span class="info-label"style="display:block;width:34%;">${intl ? intl.formatMessage({ id: 'settlement_Bank' }) : 'Bank'}:</span>
                        <span class="info-value">${settlementData.beneficiaryBankName || '-'}</span>
                    </div>
                    <div class="info-row"style=" display: flex;justify-content: flex-start;">
                        <span class="info-label"style="display:block;width:34%;">${intl ? intl.formatMessage({ id: 'settlement_BankAccount' }) : 'Bank Account'}:</span>
                        <span class="info-value">${settlementData.beneficiaryBank}</span>
                    </div>
                </div>
            </div>

            <!-- Amount & Currency Section -->
            <div class="info-section" style="margin: 16px 0;">
                <div class="info-row">
                    <strong>${intl ? intl.formatMessage({ id: 'settlement_AmountToSettleLabel' }) : 'Amount to Settle'}:</strong>
                    <span class="info-value amount-highlight">${formatAmount2(settlementData.amount)} <span>${settlementData.currency === 'EGP' ? (intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP') : (settlementData.currency || 'EGP')}</span></span>
                </div>
            </div>

            <!-- Suggested ERP Journal Entries -->
            <div class="journal-section">
                <!-- Sender Journal Entry -->
                <div style="border: 1px solid #f0f0f0; border-radius: 4px; overflow: hidden; margin-bottom: 24px;">
                    <div style="background: #fafafa; padding: 12px 16px; border-bottom: 1px solid #f0f0f0; font-weight: 500; font-size: 11px;text-align: center;">
                        ${intl ? intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntrySenderTitle' }) : 'Suggested ERP Journal Entry (Sender)'}
                    </div>
                    <table class="journal-table" style="margin-bottom: 0;">
                        <thead>
                            <tr style="background: #fafafa;">
                                <th style="flex: 3;">${intl ? intl.formatMessage({ id: 'settlement_Account' }) : 'Account'}</th>
                                <th style="flex: 1; text-align: center;">${intl ? intl.formatMessage({ id: 'settlement_Debit' }) : 'Debit'}</th>
                                <th style="flex: 1; text-align: center;">${intl ? intl.formatMessage({ id: 'settlement_Credit' }) : 'Credit'}</th>
                                <th style="flex: 2;">${intl ? intl.formatMessage({ id: 'settlement_DescriptionLabel' }) : 'Description'}</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${settlementData.senderJournalEntries ? settlementData.senderJournalEntries.map(entry => `
                                <tr>
                                    <td>${getAccountName(entry.account)}</td>
                                    <td class="amount-cell">${entry.debit ? formatAmount5(entry.debit) + ' ' + (intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP') : '-'}</td>
                                    <td class="amount-cell">${entry.credit ? formatAmount5(entry.credit) + ' ' + (intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP') : '-'}</td>
                                    <td>${entry.description}</td>
                                </tr>
                            `).join('') : ''}
                            <tr class="total-row">
                                <td><strong>${intl ? intl.formatMessage({ id: 'settlement_Total' }) : 'Total'}</strong></td>
                                <td class="amount-cell">
                                    <strong>${settlementData.senderJournalEntries ? formatAmount5(settlementData.senderJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0)) : formatAmount5(0)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}</strong>
                                </td>
                                <td class="amount-cell">
                                    <strong>${settlementData.senderJournalEntries ? formatAmount5(settlementData.senderJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0)) : formatAmount5(0)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}</strong>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Beneficiary Journal Entry -->
                <div style="border: 1px solid #f0f0f0; border-radius: 4px; overflow: hidden;">
                    <div style="background: #fafafa; padding: 12px 16px; border-bottom: 1px solid #f0f0f0; font-weight: 500; font-size: 11px;text-align: center;">
                        ${intl ? intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntryBeneficiaryTitle' }) : 'Suggested ERP Journal Entry (Beneficiary)'}
                    </div>
                    <table class="journal-table" style="margin-bottom: 0;">
                        <thead>
                            <tr style="background: #fafafa;">
                                <th style="flex: 3;">${intl ? intl.formatMessage({ id: 'settlement_Account' }) : 'Account'}</th>
                                <th style="flex: 1; text-align: center;">${intl ? intl.formatMessage({ id: 'settlement_Debit' }) : 'Debit'}</th>
                                <th style="flex: 1; text-align: center;">${intl ? intl.formatMessage({ id: 'settlement_Credit' }) : 'Credit'}</th>
                                <th style="flex: 2;">${intl ? intl.formatMessage({ id: 'settlement_DescriptionLabel' }) : 'Description'}</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${settlementData.beneficiaryJournalEntries ? settlementData.beneficiaryJournalEntries.map(entry => `
                                <tr>
                                    <td>${getAccountName(entry.account)}</td>
                                    <td class="amount-cell">${entry.debit ? formatAmount5(entry.debit) + ' ' + (intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP') : '-'}</td>
                                    <td class="amount-cell">${entry.credit ? formatAmount5(entry.credit) + ' ' + (intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP') : '-'}</td>
                                    <td>${entry.description}</td>
                                </tr>
                            `).join('') : ''}
                            <tr class="total-row">
                                <td><strong>${intl ? intl.formatMessage({ id: 'settlement_Total' }) : 'Total'}</strong></td>
                                <td class="amount-cell">
                                    <strong>${settlementData.beneficiaryJournalEntries ? formatAmount5(settlementData.beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0)) : formatAmount5(0)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}</strong>
                                </td>
                                <td class="amount-cell">
                                    <strong>${settlementData.beneficiaryJournalEntries ? formatAmount5(settlementData.beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0)) : formatAmount5(0)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}</strong>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Bank Transfer Details -->
            <div class="info-section" style="margin: 16px 0;">
                <strong style="display:block;margin: 0 0 5px 0;">${intl ? intl.formatMessage({ id: 'settlement_BankTransferDetails' }) : 'Bank Transfer Details'}</strong>
                ${(settlementData.bank_ref_no || settlementData.bank_description || settlementData.bank_transfer_date) ? `
                    <div class="info-row">
                        <span class="info-label">${intl ? intl.formatMessage({ id: 'settlement_ACHReferenceNumber' }) : 'ACH Reference No.'}:</span>
                        <span class="info-value">${settlementData.bank_ref_no || '-'}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">${intl ? intl.formatMessage({ id: 'settlement_Description' }) : 'Description'}:</span>
                        <span class="info-value">${settlementData.bank_description || '-'}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">${intl ? intl.formatMessage({ id: 'settlement_TransferDateLabel' }) : 'Transfer Date'}:</span>
                        <span class="info-value">${formatDate(settlementData.bank_transfer_date)}</span>
                    </div>
                 
                ` : `
                    <div class="info-row">
                        <span class="info-label" style="font-style: italic; color: #666;">${intl ? intl.formatMessage({ id: 'settlement_NoBankTransferDetailsEntered' }) : 'No bank transfer details entered yet'}</span>
                    </div>
                `}
            </div>

            <!-- Bank Transfer Notes -->
            <div class="info-section" style="margin: 16px 0;">
                <strong style="display:block;margin: 0 0 5px 0;">${intl ? intl.formatMessage({ id: 'settlement_BankTransferNotes' }) : 'Bank Transfer Notes'}</strong>
                <div style="padding: 8px 0;font-size: 11px;">
                    ${settlementData.notes || '<span class="info-label" style="font-size: 11px;font-style: italic; color: #666;">' + (intl ? intl.formatMessage({ id: 'settlement_NoAdditionalNotes' }) : 'No additional notes') + '</span>'}
                </div>
            </div>

            <!-- Signature Section -->
            <div class="signature-section">
                <div class="signature-box">
                    <strong>${intl ? intl.formatMessage({ id: 'settlement_FinanceManager' }) : 'Finance Manager'}</strong><br>
                    <span style="font-size: 11px;">${intl ? intl.formatMessage({ id: 'settlement_NameLabel' }) : 'Name'}: _____________________</span><br>
                    <span style="font-size: 11px;">${intl ? intl.formatMessage({ id: 'settlement_DateLabel' }) : 'Date'}: _____________________</span><br>
                    <span style="font-size: 11px;">${intl ? intl.formatMessage({ id: 'settlement_Signature' }) : 'Signature'}: _________________</span>
                </div>
                <div class="signature-box">
                    <strong>${intl ? intl.formatMessage({ id: 'settlement_GeneralManager' }) : 'General Manager'}</strong><br>
                    <span style="font-size: 11px;">${intl ? intl.formatMessage({ id: 'settlement_NameLabel' }) : 'Name'}: _____________________</span><br>
                    <span style="font-size: 11px;">${intl ? intl.formatMessage({ id: 'settlement_DateLabel' }) : 'Date'}: _____________________</span><br>
                    <span style="font-size: 11px;">${intl ? intl.formatMessage({ id: 'settlement_Signature' }) : 'Signature'}: _________________</span>
                </div>
            </div>

            <!-- Footer -->
            <div class="footer">
                <p><strong>${intl ? intl.formatMessage({ id: 'settlement_AFCSettlementSystem' }) : 'AFC Settlement System'}</strong> | ${intl ? intl.formatMessage({ id: 'settlement_GeneratedOn' }) : 'Generated on'} ${formatDate(new Date().toISOString())}</p>
            </div>
        </div>
    </body>
    </html>
  `;

    const opt = {
        margin: 0.4,
        filename: `settlement-${settlementData.id}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };

    return htmlContent;
};

/**
 * Generate and download settlement PDF using html2pdf
 * @param {Object} settlementData - Settlement data object
 * @param {Object} intl - Internationalization object for translations
 * @returns {Promise<void>} Promise that resolves when PDF is downloaded
 */
export const generateSettlementPDF = (settlementData, intl) => {
    const htmlContent = generateSettlementHTML(settlementData, intl);

    const opt = {
        margin: 0.4,
        filename: `settlement-${settlementData.id}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };

    return html2pdf().set(opt).from(htmlContent).save();
};


